/* Prénatal redesign: small behaviours that CSS alone cannot do.
   Loaded with defer from layout/theme.liquid. */
(function () {
  'use strict';

  /* Menu bubble: the dropdown is a rounded card that opens under the item being hovered.
     The theme positions the dropdown against the whole menu bar, so this works out where the
     card should sit (under the item, never past the edge of the page) and where its little tip points. */
  function placeBubble(item) {
    var menu = item.querySelector(':scope > .m-mega-menu');
    var bar = item.closest('.m-menu-bar');
    if (!menu || !bar) return;
    var barBox = bar.getBoundingClientRect();
    var itemBox = item.getBoundingClientRect();
    var gutter = 16;
    var width = menu.offsetWidth;
    var left = itemBox.left - barBox.left - 20;
    var max = barBox.width - width - gutter;
    if (left > max) left = max;
    if (left < gutter) left = gutter;
    var tip = itemBox.left - barBox.left + itemBox.width / 2 - left - 9;
    menu.style.setProperty('--pn-bubble-left', left + 'px');
    menu.style.setProperty('--pn-bubble-tip', Math.max(24, Math.min(width - 42, tip)) + 'px');
  }

  function initBubbles() {
    var items = document.querySelectorAll('.m-header__desktop .m-menu > .m-menu__item--mega');
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        placeBubble(item);
        if (item.pnBubbleBound) return;
        item.pnBubbleBound = true;
        item.addEventListener('mouseenter', function () { placeBubble(item); });
        item.addEventListener('focusin', function () { placeBubble(item); });
      })(items[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBubbles);
  } else {
    initBubbles();
  }
  window.addEventListener('resize', initBubbles);
  document.addEventListener('shopify:section:load', initBubbles);

  /* Floating app buttons moved into the page.
     "Reward" (the loyalty app) and "10% off" (a Shopify form) each float over the bottom of the screen.
     With the theme setting on, their floating buttons are hidden and the buttons marked
     data-pn-open="rewards" / data-pn-open="offer" (header and footer) open the app's own panel instead.
     Those buttons only show once the app is really on the page, so they never do nothing. */
  var root = document.documentElement;
  var moveRewards = root.classList.contains('pn-move-rewards');
  var moveOffer = root.classList.contains('pn-move-offer');

  function rewardsLauncher() {
    return document.querySelector('.BLOY-widget');
  }

  function offerTeaser() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) {
      var shadow = hosts[i].shadowRoot;
      if (!shadow) continue;
      // the form lives in its own closed-off box, so the rule that hides its floating teaser goes inside it
      if (!shadow.querySelector('style[data-pn]')) {
        var style = document.createElement('style');
        style.setAttribute('data-pn', '');
        style.textContent = '[class*="appEmbedRootTeaser"]{display:none!important}';
        shadow.appendChild(style);
      }
      var teaser = shadow.querySelector('button[class*="teaserContainer"]');
      if (teaser) return teaser;
    }
    return null;
  }

  function findMoved() {
    if (moveRewards && rewardsLauncher()) root.classList.add('pn-has-rewards');
    if (moveOffer && offerTeaser()) root.classList.add('pn-has-offer');
    return (!moveRewards || root.classList.contains('pn-has-rewards')) && (!moveOffer || root.classList.contains('pn-has-offer'));
  }

  if (moveRewards || moveOffer) {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-pn-open]') : null;
      if (!trigger) return;
      event.preventDefault();
      var target = trigger.getAttribute('data-pn-open') === 'rewards' ? rewardsLauncher() : offerTeaser();
      if (target) target.click();
      // pressed inside the phone menu: put the menu away so the app's panel is in view
      var drawer = trigger.closest('#m-menu-drawer');
      var backdrop = drawer ? drawer.querySelector('.m-menu-drawer__backdrop') : null;
      if (backdrop) backdrop.click();
    });
    // the apps load late: look often for the first half minute, then now and then
    var looks = 0;
    var timer = setInterval(function () {
      looks++;
      if (findMoved() || looks > 75) {
        clearInterval(timer);
        if (looks > 75) setInterval(findMoved, 4000);
      }
    }, 400);
    if (window.MutationObserver && document.body) {
      new MutationObserver(findMoved).observe(document.body, { childList: true });
    }
  }

  /* Search: an icon beside Account. Pressing it slides a small search bar out beside the icons;
     pressing it again, pressing Escape or clicking anywhere else puts it away.
     (The theme would open its full-screen search from this icon, so the click is taken here first.) */
  var SEARCH_ICON = '.m-header__desktop .m-header__top .m-header__right .m-header__search';
  var SEARCH_BAR = '.m-header__desktop .m-header__top [data-search-popup-wrap]';

  function setSearch(show) {
    root.classList.toggle('pn-search-show', show);
    var bar = document.querySelector(SEARCH_BAR);
    var input = bar ? bar.querySelector('[data-search-input]') : null;
    var icon = document.querySelector(SEARCH_ICON + ' .m-search-form__button');
    if (icon) icon.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (!input) return;
    if (show) {
      // sit just left of the Search icon, however many icons there are
      var inner = bar.closest('.m-header__inner');
      var iconBox = document.querySelector(SEARCH_ICON);
      if (inner && iconBox) {
        bar.style.setProperty('--pn-search-right', Math.round(inner.getBoundingClientRect().right - iconBox.getBoundingClientRect().left + 8) + 'px');
      }
      input.focus();
    } else {
      input.blur();
      var panel = bar.querySelector('[data-pn-search]');
      if (panel) panel.classList.remove('is-open');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest || !document.querySelector(SEARCH_BAR)) return;
    if (target.closest(SEARCH_ICON)) {
      event.preventDefault();
      event.stopPropagation();
      setSearch(!root.classList.contains('pn-search-show'));
      return;
    }
    if (root.classList.contains('pn-search-show') && !target.closest(SEARCH_BAR)) setSearch(false);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('pn-search-show')) setSearch(false);
  });

  /* SPEED. Product rows with tabs build only what is needed when the page loads:
     the first tab, and in each tab the first 4 products. The rest wait inside <template> tags
     (sections/product-tabs.liquid): "pn-lazy-tab" holds a whole tab, "pn-lazy-more" holds a tab's
     products after the fourth. They are put in place the moment someone points at, touches or
     tabs into that row. */
  function markSaved() {
    // the theme marks saved (wishlist / compare) products when the page loads, so mark the new cards too
    var theme = window.MinimogTheme || {};
    if (theme.Wishlist && theme.Wishlist.setWishlistButtonsState) theme.Wishlist.setWishlistButtonsState();
    if (theme.CompareProduct && theme.CompareProduct.setCompareButtonsState) theme.CompareProduct.setCompareButtonsState();
  }
  function fillTabs(scope) {
    var waiting = (scope || document).querySelectorAll('template.pn-lazy-tab');
    if (!waiting.length) return;
    for (var i = 0; i < waiting.length; i++) waiting[i].replaceWith(waiting[i].content);
    markSaved();
  }
  /* the rest of the products of the tab that is open (not of every tab: that would be a lot at once) */
  function fillMore(row) {
    var tab = row.querySelector('.m-tab-content.active') || row.querySelector('.m-tab-content');
    var waiting = tab ? tab.querySelectorAll('template.pn-lazy-more') : [];
    if (!waiting.length) return;
    for (var i = 0; i < waiting.length; i++) waiting[i].replaceWith(waiting[i].content);
    markSaved();
    syncRow(row);
  }
  ['pointerover', 'pointerdown', 'touchstart', 'focusin', 'click', 'change'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var row = event.target && event.target.closest ? event.target.closest('m-product-tabs') : null;
      if (!row) return;
      fillTabs(row);
      fillMore(row);
      // a click may have opened another tab: once the theme has switched, fill that one too
      if (type === 'click' || type === 'change') setTimeout(function () { fillMore(row); syncRow(row); }, 80);
    }, { capture: true, passive: true });
  });
  document.addEventListener('shopify:section:load', function (event) { fillTabs(event.target); });

  /* Style E tile video. There can be one for computers and one for phones; only the one that is
     showing is loaded and played, and it waits until the tile is close to the screen. */
  function runTileVideo(video, near) {
    var showing = video.offsetParent !== null;
    if (showing && near) {
      video.muted = true;
      if (video.paused) {
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      }
    } else if (!video.paused) {
      video.pause();
    }
  }
  function initTileVideos() {
    var videos = document.querySelectorAll('.pn-row__tile video');
    for (var i = 0; i < videos.length; i++) {
      (function (video) {
        if (video.pnWatched) return;
        video.pnWatched = true;
        if (!window.IntersectionObserver) { runTileVideo(video, true); return; }
        // watch the tile, not the video: a hidden video has no size, so it would never count as near
        new IntersectionObserver(function (entries) {
          video.pnNear = entries[entries.length - 1].isIntersecting;
          runTileVideo(video, video.pnNear);
        }, { rootMargin: '300px 0px' }).observe(video.closest('.pn-row__tile'));
      })(videos[i]);
    }
  }
  initTileVideos();
  document.addEventListener('shopify:section:load', initTileVideos);
  window.addEventListener('resize', function () {
    var videos = document.querySelectorAll('.pn-row__tile video');
    for (var i = 0; i < videos.length; i++) runTileVideo(videos[i], videos[i].pnNear !== false);
  });

  /* Product rows are carousels on tablets and computers: the products slide sideways.
     This puts two arrows at the end of the tab line (and, in the photo row, View all beside them)
     and keeps them in step with the tab that is open. */
  var CHEVRON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';

  function rowTab(row) {
    return row.querySelector('.m-tab-content.active') || row.querySelector('.m-tab-content');
  }
  function rowTrack(row) {
    var tab = rowTab(row);
    return tab ? tab.querySelector('.m-mixed-layout__inner:not(.swiper-wrapper)') : null;
  }
  function syncRow(row) {
    var controls = row.pnControls;
    if (!controls) return;
    var tab = rowTab(row);
    var url = tab ? tab.getAttribute('data-url') : '';
    if (url) controls.link.href = url;
    var track = rowTrack(row);
    var room = track ? track.scrollWidth - track.clientWidth : 0;
    // products that are still waiting to be built count as "there is more to see"
    var waiting = !!(track && track.querySelector('template.pn-lazy-more'));
    controls.box.classList.toggle('is-still', room <= 4 && !waiting);
    controls.prev.disabled = !track || track.scrollLeft <= 4;
    controls.next.disabled = !track || (!waiting && track.scrollLeft >= room - 4);
  }
  function initRows() {
    var rows = document.querySelectorAll('m-product-tabs');
    for (var i = 0; i < rows.length; i++) {
      (function (row) {
        var header = row.querySelector('.m-section__header');
        if (row.pnControls || !header || !rowTrack(row)) return;
        var words = row.querySelector('.m-product-tabs__load-more a span, .pn-row__tile-btn');
        var box = document.createElement('div');
        box.className = 'pn-row__controls';
        box.innerHTML = '<a class="pn-row__viewall" href="#"></a>' +
          '<button type="button" class="pn-row__arrow pn-row__arrow--prev" aria-label="Previous products">' + CHEVRON + '</button>' +
          '<button type="button" class="pn-row__arrow" aria-label="Next products">' + CHEVRON + '</button>';
        var link = box.querySelector('a');
        var arrows = box.querySelectorAll('button');
        link.textContent = (words && words.textContent.trim()) || 'View all';
        arrows[0].firstChild.style.transform = 'rotate(180deg)';
        header.appendChild(box);
        row.pnControls = { box: box, link: link, prev: arrows[0], next: arrows[1] };
        function slide(direction) {
          fillMore(row);
          var track = rowTrack(row);
          if (!track) return;
          var from = track.scrollLeft;
          var to = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, from + direction * track.clientWidth));
          track.scrollTo({ left: to, behavior: 'smooth' });
          // if the browser did not animate (it can skip that), jump there instead of doing nothing
          setTimeout(function () {
            if (to !== from && Math.abs(track.scrollLeft - from) < 2) track.scrollLeft = to;
            syncRow(row);
          }, 450);
          setTimeout(function () { syncRow(row); }, 900);
        }
        arrows[0].addEventListener('click', function () { slide(-1); });
        arrows[1].addEventListener('click', function () { slide(1); });
        // scroll events do not bubble, so they are caught on the way down
        row.addEventListener('scroll', function () { syncRow(row); }, true);
        syncRow(row);
      })(rows[i]);
    }
  }
  function syncRows() {
    var rows = document.querySelectorAll('m-product-tabs');
    for (var i = 0; i < rows.length; i++) syncRow(rows[i]);
  }
  initRows();
  window.addEventListener('load', syncRows);
  window.addEventListener('resize', syncRows);
  document.addEventListener('shopify:section:load', initRows);
})();
